import { LocalDate } from '../../core/model/local-date';
import { ModelBase } from '../../core/model/model-base';

export class LeaseAgreementImdConsumption extends ModelBase {
  constructor(model: any) {
    super();
    if (model) {
      this.consumptionDate = model.consumptionDate;
      this.consumption = model.consumption;
      this.meterShare = model.meterShare;
      this.invoiceNumber = model.invoiceNumber;
      this.invoicePeriod = model.invoicePeriod;
      this.imdMeterName = model.imdMeterName;
      this.meterTypeDescription = model.meterTypeDescription;
    }
  }

  private _consumptionDate: LocalDate;
  consumption: number;
  meterShare: number;
  invoiceNumber: number;
  invoicePeriod: string;
  imdMeterName: string;
  meterTypeDescription: string;

  get consumptionDate(): LocalDate {
    return this._consumptionDate;
  }
  set consumptionDate(value: LocalDate) {
    this._consumptionDate = LocalDate.fromDate(value);
  }
}
